import { View, Text, Image, Dimensions, Platform } from "react-native";
import React, { useEffect } from "react";
import MyView from "../../components/custom/MyView";
import { lightBlue } from "../../colors";
import { kidsWithDoctor } from "../../imports";
import MyText from "../../components/custom/MyText";
import { ScrollView } from "react-native-gesture-handler";
import WelcomeUser from "../../components/home/WelcomeUser";
import translate from "../../functions/translate";
import Wallet from "../../components/home/Wallet";
import GrowTest from "../../components/home/GrowTest";
import ASQ3Test from "../../components/home/ASQ3Test";
import ASQSE2Test from "../../components/home/ASQSE2Test";
import ADHDTest from "../../components/home/ADHDTest";
import LearningSlider from "../../components/home/LearningSlider";
import { useDispatch, useSelector } from "react-redux";
import {
  changeHeaderColor,
  hideBackButton,
} from "../../redux/header/headerAction";
import { useIsFocused } from "@react-navigation/native";
import TestDetails from "../test/TestDetails";
import { useState } from "react";
import getTestDetails from "../../api/home/getTestDetails";
import { setUserInformation } from "../../redux/user/userAction";
import { addToken } from "../../redux/main/mainAction";
import userValidInformation from "../../api/post/userValidInformation";
import { getStringData, storeStringData } from "../../functions/db/db";
import Cookies from "universal-cookie";
import UserHelper from "../../components/home/UserHelper";
import FAQVideo from "../../components/home/FAQVideo";

export default function Home() {
  const dispatch = useDispatch();
  const user = useSelector((store) => store.user);
  const main = useSelector((store) => store.main);
  const [testDetails, setTestDetails] = useState({
    ADHD: { participant: 0, Percent: 0 },
    ASQ3: { participant: 4, Percent: 0 },
    ASQSE2: { participant: 1, Percent: 0 },
    Growth: { participant: 2, Percent: 0 },
  });

  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor(lightBlue));
      dispatch(hideBackButton());
    }
  }, [isFocused]);
  // useEffect(() => {
  //   if (isFocused) {
  //     getTestDetails()
  //       .then(({ data }) => {
  //         if (data.status === 200) {
  //           setTestDetails(data.data);
  //         }
  //       })
  //       .catch((err) => {});

  //     if (Platform.OS !== "web") {
  //       getStringData("token")
  //         .then((data) => {
  //           if (data === null) {
  //           } else {
  //             const myToken = data;
  //             userValidInformation(data)
  //               .then(({ data }) => {
  //                 if (data.status === 200) {
  //                   dispatch(setUserInformation(data.data));
  //                   dispatch(addToken(myToken));
  //                 } else {
  //                   storeStringData("token", null);
  //                   dispatch(setUserInformation({}));
  //                 }
  //               })
  //               .catch((error) => {
  //                 storeStringData("token", null);
  //                 dispatch(setUserInformation({}));
  //               });
  //           }
  //         })
  //         .catch((error) => {
  //           storeStringData("token", null);
  //           dispatch(setUserInformation({}));
  //         });
  //     } else {
  //       const cookies = new Cookies();
  //       const tok = cookies.get("token");

  //       if (tok === null) {
  //       } else {
  //         const myToken = tok;
  //         userValidInformation(myToken)
  //           .then(({ data }) => {
  //             if (data.status === 200) {
  //               dispatch(setUserInformation(data.data));
  //               dispatch(addToken(myToken));
  //             } else {
  //               cookies.set("token", null);
  //               dispatch(setUserInformation({}));
  //             }
  //           })
  //           .catch((error) => {
  //             cookies.set("token", null);
  //             dispatch(setUserInformation({}));
  //           });
  //       }
  //     }
  //   }
  // }, [isFocused]);

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={{ alignItems: "center" }}>
        <View style={{ alignItems: "center" }}>
          <View
            style={{
              backgroundColor: lightBlue,
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
              width: "100%",
            }}
          >
            <Image
              source={kidsWithDoctor}
              style={{ width: 300, height: 300 }}
            />
          </View>
          <View
            style={{
              width: Dimensions.get("screen").width * 2,
              height: Dimensions.get("screen").width * 2,
              marginTop: -1.85 * Dimensions.get("screen").width,

              borderRadius: 2000,
              backgroundColor: lightBlue,
            }}
          ></View>
        </View>

        <WelcomeUser
          name={user.information.name}
          active={user.information.active}
        />
        <FAQVideo />
        <Wallet />

        <UserHelper />
        <LearningSlider />
        <View style={{ height: 100 }}></View>
      </View>
    </ScrollView>
  );
}
